import TkgGoldBuyingAndSelling from '../contracts/TkgGoldBuyingAndSelling';

const options = {
  contracts: [ TkgGoldBuyingAndSelling ],
  web3: {
    fallback: {
      type: "ws",
      //url: "ws://127.0.0.1:7545",
      url: "wss://sepolia.infura.io/ws/v3/f28ea5b67cc84371990f18cc8f65afaa"
    },
  },
};

export default options;
